import { lazy } from "react";
import category from "./category";
import salesMonth from "./salesMonth";
import customOrder from "./customOrder";
import goodTotal from "./goodTotal";
import shipment from "./shipment";
import customAnalysis from "./customAnalysis";
const Analysis = lazy(() => import("../view/analysis/Analysis"));
const Details = lazy(() => import("../view/details/Details"));
const InventoryDay = lazy(() => import("../view/inventoryDay/InventoryDay"));
const Goodlist = lazy(() => import("../view/goodlist/Goodlist"))
const orderDailyPaper = lazy(() => import("../view/orderDailyPaper/orderDailyPaper"))
const noOutDetail = lazy(() => import("../view/noOutDetail/NoOutDetail"))
const InventoryDay2 = lazy(() => import("../view/inventoryDay2/InventoryDay"));
const Goodlist2 = lazy(() => import("../view/goodlist2/Goodlist"));
const gylDailyForm = lazy(() => import("../view/gylDailyForm/GylDailyForm"));
const OutboundAnalysis = lazy(() => import("../view/outbound/OutboundAnalysis"));
const routes = [
  // {
  //   path: "/",
  //   element: <Navigate to="/analysis" replace />
  // },
  /**
   * 展厅库存分析
   */
  {
    path: "/analysis",
    // path: "/",
    component: Analysis,
    id:"analysis"
  },
  {
    path: "/details",
    component: Details,
    id:"details"
  },
  /**
   * 版库设计
   */
  {
    path: "/inventoryDay",
    component: InventoryDay,
    id:"inventoryDay"
  },
  {
    path: "/goodlist",
    component: Goodlist,
    id:"goodlist"
  },
  /**
   * 贵宝镶嵌部订单组日报
   */
  {
    path: "/orderDailyPaper",
    component: orderDailyPaper,
    id:"orderDailyPaper"
  },
  {
    path: "/noOutDetail",
    component: noOutDetail,
    id:"noOutDetail"
  },
  /**
   * 明丰版库设计
   */
  {
    path: "/mfInventoryDay",
    component: InventoryDay2,
    id:"mfInventoryDay"
  },
  {
    path: "/mfGoodlist",
    component: Goodlist2,
    id:"mfGoodlist"
  },
  /**
   * 展厅品类&客户分析
   */
  {
    path: "/categoryCustom",
    children:category,
    id:"categoryCustom"
  },
  /**
   * 展厅客户分析
   */
  {
    path: "/customAnalysis",
    children:customAnalysis,
    id:"customAnalysis"
  },
  {
    path: "/outbound",
    component: OutboundAnalysis,
    id: "outboundAnalysis"
  },
  /***
   * 月度业绩报表&业务员出货报表
   */
  {
    path: "/salesMonth",
    children:salesMonth,
    id:"salesMonth"
  },
  /**
   * 供应链每日报表
   */
  {
    path: "/gylDailyForm",
    component:gylDailyForm,
    id:"gylDailyForm"
  },
  /**
   * 客订单
   */
  {
    path:"customOrder",
    children:customOrder,
    id:"customOrder"
  },
  // 统计
  {
    path:"goodTotal",
    children:goodTotal,
    id:"goodTotal"
  },
  // 展厅出货数据
  {
    path:"shipment",
    children:shipment,
    id:"shipment"
  },
  // 展厅客户分析
  {
    path:"customAnalysis",
    children:customAnalysis,
    id:"customAnalysis"
  }
];
export default routes;
